<template>
  <div id="app">
    <notifications position="top right" />
    <router-view />
  </div>
</template>

<script>
import { subscribe } from '@/services/action_cable.service';
import { mapState } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      nonZoomRoutes: ['Login', 'ResetPassword'],
      channel: null,
      enableSockets: true,
    };
  },
  created() {
    this.setupSocket();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    if (this.channel && this.enableSockets) {
      this.channel.unsubscribe();
      delete this.channel;
    }
  },
  methods: {
    onResize() {
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    },
    setupSocket() {
      if (this.currentUser && this.currentUser.data && this.currentUser.data.id && this.enableSockets) {
        this.channel = subscribe('UsersChannel', this.currentUser.data.id, {});
      }
    },
  },
  computed: {
    ...mapState(['currentUser']),
  },
  watch: {
    currentUser(oldVal, newVal) {
      if (oldVal !== newVal) {
        if (this.channel && this.enableSockets) {
          this.channel.unsubscribe();
          delete this.channel;
        }
        this.setupSocket();
      }
    },
    $route(to, from) {
      if (to !== from && !this.nonZoomRoutes.includes(to.name)) {
        this.onResize();
        this.$nextTick(() => {
          window.addEventListener('resize', this.onResize);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #app {
    height: 100%;
    overflow: hidden;
  }
</style>

<style lang="scss">
  html, body {
    height: 100%;
  }
</style>
